// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3NVwW","actions":"GroupTable_actions__21sVL","deleteModalFooter":"GroupTable_deleteModalFooter__2Mn1p"};